<template>
  <div :class="layout">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: ["layout"],
};
</script>

<style scoped>
div {
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
}

.basecard {
  height: 19.4rem;
}

.grid-basecard {
  display: grid;
  grid-template-columns: 0.85fr 1.45fr 6.85fr 0.85fr;
}

@media (max-width: 90em) { /* 1440px */
  .basecard {
    height: 17.6rem;
  }
}
</style>
